module.exports = __webpack_public_path__ + "static/img/anxun1.5f04e25d.png";